/**
 * Produces a stable string key from the sort model that encodes both columns
 * and their priority order.
 *
 * The input must already be ordered by sort priority (sortIndex). The key is
 * order-dependent: `name:ASC,age:DESC` differs from `age:DESC,name:ASC`
 * because sort priority matters for multi-column sorting.
 *
 * Column drag-and-drop (which changes columnStates array order) does NOT cause
 * spurious refetches because `sortKeyOf` in GridLifecycle sorts by `sortIndex`
 * before building the key.
 */
export const computeSortModelKey = (
  sortModel: ReadonlyArray<{columnKey: string; order: string}>
): string => sortModel.map((s) => `${s.columnKey}:${s.order}`).join(',');
